module.exports = __webpack_public_path__ + "static/media/bgCurrency.0d048b43.jpg";